const _trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');

const TOKEN_KEY = 'haapa.authToken';
const USER_KEY = 'haapa.currentUser';

type _GraphQLResult<T> = {
  data?: T;
  errors?: { message?: string }[];
};

const getStoredToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(TOKEN_KEY);
};

const getStoredUser = (): Record<string, unknown> => {
  if (typeof window === 'undefined') return {};
  const raw = window.localStorage.getItem(USER_KEY);
  if (!raw) return {};
  try {
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return {};
  }
};

export async function graphqlRequest<TData>(
  _query: string,
  _variables?: Record<string, unknown>,
  _options: { requireAuth?: boolean } = {},
): Promise<TData> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: '*/*',
  };

  if (_options.requireAuth) {
    const token = getStoredToken();
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const storedUser = getStoredUser();
    const userId = typeof storedUser.id === 'string' ? storedUser.id : undefined;
    const role = typeof storedUser.role === 'string' ? storedUser.role : undefined;
    const audience = typeof storedUser.audience === 'string' ? storedUser.audience : undefined;

    if (userId) headers['x-user-id'] = userId;
    if (role) headers['x-user-role'] = role;
    if (audience) headers['x-user-audience'] = audience;
  }

  // bn backend has no GraphQL; return empty result immediately.
  return Promise.resolve({} as TData);
}
